import React from "react";
import styled from "@emotion/styled";
import { Moment } from "moment";

import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import MuiTextField from "@mui/material/TextField";

const Container = styled.div`
  width: 100%;
  max-width: 175px;
`;

const StyledMuiTextField = styled(MuiTextField)`
  width: 100%;

  & .MuiInput-input {
    cursor: pointer;
  }
`;

type Props = {
  disabled?: boolean;
  inputFormat?: string;
  label?: string;
  shouldDisableDate?: (day: any) => boolean;
  onChange: (value: any, keyboardInputValue?: string | undefined) => void;
  value: string | Moment;
};

function DatePicker({
  disabled,
  inputFormat,
  label,
  shouldDisableDate,
  value,
  onChange,
}: Props): JSX.Element {
  return (
    <Container>
      <MobileDatePicker
        closeOnSelect
        inputFormat={inputFormat}
        disabled={disabled}
        label={label}
        value={value}
        onChange={onChange}
        shouldDisableDate={shouldDisableDate}
        renderInput={(params) => (
          <StyledMuiTextField {...params} variant="standard" />
        )}
      />
    </Container>
  );
}

DatePicker.defaultProps = {
  label: "",
  inputFormat: "D MMMM YYYY",
  onChange: () => {},
};

export default DatePicker;
